"use client";

import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "../_primitives/CustomSVG/CustomSVG.client";
import styles from "./MediaItem.module.scss";

// MediaItem must stay renderable from server components, so the
// useGlobalContext() label lookup lives in this client child.
export const MediaItemPlayIcon = () => {
  const { label } = useGlobalContext();

  return (
    <div aria-hidden={true} className={styles["play-icon"]}>
      <CustomSVG
        iconKey="play"
        wrapper={"span"}
        width={16}
        height={16}
        alt={label("vidstack", null, "vidstack", {
          de: "Wiedergabe",
          en: "Play",
        })}
        className="is-flex"
      />
    </div>
  );
};
